@if (dates.length > 0) {
    <mat-chip-set class="d-flex mb-1" aria-label="Herhalingen">
        @if (current?.getTime() < first?.getTime()) {
            <mat-chip
                class="current"
                [matTooltip]="'Huidige planning:\n' + (current | date: 'EEEE dd MMMM yyyy - hh:mm')">
                {{ current | date: 'EEE d MMM yyyy' }}
            </mat-chip>
        }

        @if (first) {
            <mat-chip class="first" [matTooltip]="'Eerste planning:\n' + (first | date: 'EEEE dd MMMM yyyy - hh:mm')">
                {{ first | date: 'EEE d MMM yyyy' }}
            </mat-chip>
        }

        @if (history.length) {
            <mat-chip
                class="history"
                [matTooltip]="
                    history.length +
                    ' ' +
                    (history.length > 1 ? 'planningen' : 'planning') +
                    ' voor huidige: \n' +
                    list(history)
                ">
                {{ history.length }}&times;
            </mat-chip>
        }

        @if (current?.getTime() > first?.getTime() && current?.getTime() < last?.getTime()) {
            <mat-chip
                class="current"
                [matTooltip]="'Huidige planning:\n' + (current | date: 'EEEE dd MMMM yyyy - hh:mm')">
                {{ current | date: 'EEE d MMM yyyy' }}
            </mat-chip>
        }

        @if (future.length) {
            <mat-chip
                class="future"
                [matTooltip]="
                    future.length +
                    ' ' +
                    (future.length > 1 ? 'planningen' : 'planning') +
                    ' na huidige: \n' +
                    list(future)
                ">
                {{ future.length }}&times;
            </mat-chip>
        }

        @if (last) {
            <mat-chip class="last" [matTooltip]="'Laatste planning:\n' + (last | date: 'EEEE dd MMMM yyyy - hh:mm')">
                {{ last | date: 'EEE d MMM yyyy' }}
            </mat-chip>
        }

        @if (current?.getTime() > last?.getTime()) {
            <mat-chip
                class="current"
                [matTooltip]="'Huidige planning:\n' + (current | date: 'EEEE dd MMMM yyyy - hh:mm')">
                {{ current | date: 'EEE d MMM yyyy' }}
            </mat-chip>
        }

        <mat-chip class="total ms-auto mb-3" [matTooltip]="dates.length + ' planningen totaal'">
            Reeks: {{ dates.length }}&times;
        </mat-chip>
    </mat-chip-set>

    <mat-progress-bar class="mb-4" [value]="progress" mode="determinate"></mat-progress-bar>
}
